import {
  AuthService,
  ProductService,
} from "../../../../../shared/services";
import {
  FlexContainer,
  Input,
  ModalComponent,
  SapphireBlueButton,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import React, { FC, useState } from "react";

type IProps = {
  quantity: number;
  productId: string;
  onClose: () => void;
  isInStock: boolean;
  onUpdate: (quantity: number, isInStock: boolean) => void;
};

const InventoryOnHandPopUp: FC<IProps> = ({
  quantity,
  productId,
  onClose,
  isInStock,
  onUpdate,
}) => {
  const [onHandQuantity, setQuantity] = useState<number>(quantity);
  function onSubmit() {
    if (!onHandQuantity) {
      return;
    }

    ProductService.updateInventorySettings(
      AuthService.authData.accountId,
      productId,
      onHandQuantity,
      isInStock
    ).subscribe({
      next: (response) => {
        if (response) {
          onUpdate(onHandQuantity, isInStock);
          onClose();
        } else {
          ToastService.showError("Error Occured");
        }
      },
      error: () => {
        ToastService.showError("Error Occured");
      },
    });
  }
  return (
    <ModalComponent
      title="Inventory On Hand"
      titleFontSize="22px"
      bodyPadding="50px 30px"
      onClose={() => onClose && onClose()}
      showFooter={true}
      wrapperWidth="600px"
      bodyBackgroundColor="#F4F7FB"
      footerHeight="auto"
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <SapphireBlueButton
            minWidth="120px"
            height="40px"
            onClick={() => onClose()}
          >
            Cancel
          </SapphireBlueButton>
          <SapphireBlueButton
            primary
            minWidth="120px"
            height="40px"
            onClick={() => onSubmit()}
          >
            Save
          </SapphireBlueButton>
        </FlexContainer>
      }
    >
      <FlexContainer alignItems="center" justifyContent="center">
        <Input
          type="number"
          value={onHandQuantity}
          onChange={(e) => {
            setQuantity(e.target.value);
          }}
        />
      </FlexContainer>
    </ModalComponent>
  );
};

export default InventoryOnHandPopUp;
